:host {
  display: block;
  width: 100%;

  .progress-tracker--horizontal,
  .progress-tracker--vertical {
    display: flex;
    flex-wrap: nowrap;
    gap: var-rem(--semantic-spacing-md);
  }

  .progress-tracker--vertical {
    flex-direction: column;
  }

  .progress-tracker--horizontal {
    flex-direction: row;
  }
}
